import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-edd3ab58"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "activity" }
const _hoisted_2 = { class: "activity-header" }
const _hoisted_3 = { class: "activity-header-tab abs" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/activity/valentinesday/gift_bt.png",
  alt: ""
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/activity/valentinesday/couple_bt.png",
  alt: ""
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "activity-header-fixed flex-center" }
const _hoisted_9 = { class: "activity-content" }
const _hoisted_10 = { class: "activity-content-goods cloth" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "activity-content-goods-title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://static-s.theckb.com/BusinessMarket/Client/activity/valentinesday/gift.png",
    alt: ""
  })
], -1))
const _hoisted_12 = { class: "activity-goods-container" }
const _hoisted_13 = { class: "activity-goods bg-tab" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("See more ")
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 1,
  class: "activity-empty"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/activity/christmas/empty.png",
  alt: ""
}, null, -1))
const _hoisted_18 = { class: "activity-content-goods mt_40 groceries" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "activity-content-goods-title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://static-s.theckb.com/BusinessMarket/Client/activity/valentinesday/couple.png",
    alt: ""
  })
], -1))
const _hoisted_20 = { class: "activity-goods-container" }
const _hoisted_21 = { class: "activity-goods bg-tab" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" See more ")
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = {
  key: 1,
  class: "activity-empty"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/activity/christmas/empty.png",
  alt: ""
}, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/activity/christmas/back.png",
  alt: ""
}, null, -1))
const _hoisted_27 = [
  _hoisted_26
]

import { t } from '@/plugins/i18n'
import { useSite, useSite2Station } from '@/store'
import GoodsItemVday from './components/GoodsItemVday.vue'
import { onMounted, ref, onUnmounted } from 'vue'
import { ElMessage } from 'element-plus'
import { searchProducts } from '@/apis/search'
import { productFavorite, productFavoriteCancel } from '@/apis/goods'
import { confirmLogin } from '@/util/useConfirm'
import { useStore } from 'vuex'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const loading1 = ref(false)
const loading2 = ref(false)
const isGro = ref(false)
const showBackup = ref(false)
let cloPageNum = 1
const cloFinish = ref(false)
const clothData = ref([])

const store = useStore()

let groPageNum = 1
const groFinish = ref(false)
const groData = ref([])
const handleScroll = (e: any) => {
  if (e.target.scrollTop > 500 && !showBackup.value) {
    showBackup.value = true
  }
  if (e.target.scrollTop < 500 && showBackup.value) {
    showBackup.value = false
  }
  // console.log(e.target.scrollTop)
  const groEle = document.querySelector('.groceries')
  // console.log(groEle?.getBoundingClientRect().top)
  const topNum = groEle?.getBoundingClientRect().top || 1000
  if (topNum < 180 && !isGro.value) {
    isGro.value = true
  }
  if (topNum > 180 && isGro.value) {
    isGro.value = false
  }
}
// type 1 gift 2Couple
const getList = (type: number) => {
  if (type === 4) {
    loading1.value = true
  } else {
    loading2.value = true
  }
  searchProducts({
    pageSize: 50,
    pageNum: type === 4 ? cloPageNum : groPageNum,
    christmasTag: type === 4 ? 4 : 5,
    stationCode: useSite2Station()
    // abUser: false
  }).then((res) => {
    const { data } = res
    if (type === 4) {
      cloFinish.value = data.records?.length === 0
      clothData.value = clothData.value.concat(data.records)
    } else {
      groFinish.value = data.records?.length === 0
      groData.value = groData.value.concat(data.records)
    }
  }).finally(() => {
    if (type === 4) {
      loading1.value = false
    } else {
      loading2.value = false
    }
  })
}
const getMore = (type: number) => {
  if (type === 4) {
    cloPageNum++
  } else {
    groPageNum++
  }
  getList(type)
}
onMounted(() => {
  getList(4)
  getList(5)
  window.addEventListener('scroll', handleScroll, true)
})
onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll, true)
})
const jump = (ele: string) => {
  const element: any = document.querySelector('.' + ele)
  const scrollTop = element?.offsetTop - 170
  const scrollEle: any = document.querySelector('.el-scrollbar__wrap')
  scrollEle.scrollTop = scrollTop
}
const changeCollect = async (record: { productCode: string, favoriteFlag: number }) => {
  confirmLogin(async () => {
    const formData = {
      productCode: record.productCode
    }
    const api = record.favoriteFlag ? productFavoriteCancel : productFavorite
    await api(formData)

    !record.favoriteFlag && ElMessage.success(t('商品收藏成功'))
    record.favoriteFlag = record.favoriteFlag ? 0 : 1
  })
}

const checkLogin = (e:any) => {
  if (!store.getters.isLogin) {
    e.preventDefault()
    confirmLogin(() => {})
  }
}

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "activity-header-tab-item bg-tab btn-color2",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (jump('cloth')))
        }, _hoisted_5),
        _createElementVNode("div", {
          class: "activity-header-tab-item bg-tab ml_60 btn-color2",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (jump('groceries')))
        }, _hoisted_7)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", {
        class: _normalizeClass(["activity-header-fixed-item btn-color", { active: !isGro.value }]),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (jump('cloth')))
      }, "Love Gift Selection ", 2),
      _createElementVNode("div", {
        class: _normalizeClass(["activity-header-fixed-item btn-color", { active: isGro.value }]),
        style: {"margin-left":"324px"},
        onClick: _cache[3] || (_cache[3] = ($event: any) => (jump('groceries')))
      }, "Couple's Clothing", 2)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clothData.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "activity-goods-item",
                key: index
              }, [
                _createVNode(GoodsItemVday, {
                  item: item,
                  index: index,
                  onChange: changeCollect
                }, null, 8, ["item", "index"])
              ]))
            }), 128)),
            ((!cloFinish.value || clothData.value.length >= 1000) && clothData.value.length > 0)
              ? _withDirectives((_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "activity-goods-btn btn-click",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (getMore(4)))
                }, _hoisted_15, 512)), [
                  [_directive_loading, loading1.value]
                ])
              : _createCommentVNode("", true),
            (clothData.value.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _hoisted_17,
                  _createElementVNode("div", null, _toDisplayString(_unref(t)('没有搜索结果')), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groData.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "activity-goods-item",
                key: index
              }, [
                _createVNode(GoodsItemVday, {
                  item: item,
                  index: index,
                  onChange: changeCollect
                }, null, 8, ["item", "index"])
              ]))
            }), 128)),
            ((!groFinish.value || groData.value.length >= 1000) && groData.value.length > 0)
              ? _withDirectives((_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "activity-goods-btn btn-click",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (getMore(5)))
                }, _hoisted_23, 512)), [
                  [_directive_loading, loading2.value]
                ])
              : _createCommentVNode("", true),
            (groData.value.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _hoisted_25,
                  _createElementVNode("div", null, _toDisplayString(_unref(t)('没有搜索结果')), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _withDirectives(_createElementVNode("div", {
      class: "backup flex-center",
      onClick: _cache[6] || (_cache[6] = ($event: any) => (jump('activity')))
    }, _hoisted_27, 512), [
      [_vShow, showBackup.value]
    ])
  ]))
}
}

})